module.exports = __webpack_public_path__ + "media/images/new/icons/help-7639ea9e97f28b8f75870730a3befd54.svg";